import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonDropdown, GetAuctionStep1 } from '../../../models';
import { AuctionService, LoaderService } from '../../../services';
import constants from '../../../utility/constants';
import { ImportResultService, PagingModel } from '../service/import-result.service';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-auction-result',
  templateUrl: './auction-result.component.html',
  styleUrls: ['./auction-result.component.css']
})
export class AuctionResultComponent implements OnInit {
  displayedColumns: string[] = ['lotDes', 'location', 'quantity', 'startPrice', 'endTime', 'priceSold', 'winningBidder'];

  lotResults: Array<ImportedAuctionUser> = [];
  totalCount: number = 0;

  auctionId: number;
  auctionData: GetAuctionStep1;
  auctionsDD: Array<CommonDropdown> = [];

  searchTerm: string = '';
  pageNumber: number = 1;
  pageSize: number = constants.admin.adminPageSize;
  private subscriptions: Array<Subscription> = [];

  constructor(private importResult: ImportResultService, private router: Router, private route: ActivatedRoute, private loader: LoaderService, private auctionService: AuctionService) { }

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      let param = res['id'];
      if (param) {
        if (typeof +param == 'number') {
          this.auctionId = +param;
          this.getAuctionData();
        }
      } else {
        this.goBack();
      }
    });
    this.auctionsForDD();
  }

  auctionsForDD() {
   const aucDD =  this.importResult.getAuctionsForDD().subscribe((res) => {
      this.auctionsDD = res;
    });
    this.subscriptions.push(aucDD);
  }

  private getAuctionData() {
    const aucStep = this.auctionService.getAuctionStep1(this.auctionId).subscribe((res) => {
      this.auctionData = res;
    });
    this.subscriptions.push(aucStep);
    this.getLotResults();
  }

  onAuctionChange(value: number) {
    this.auctionId = value;
    this.getAuctionData();
  }

  changeSearchValue(val: Observable<string>) {
   const vals =  val.subscribe((value) => {
      this.searchTerm = value;
      this.pageNumber = 1;
      this.getLotResults();
    });
    this.subscriptions.push(vals);
  }

  private pagingParams(): PagingModel {
    return {
      pageNum: this.pageNumber,
      pageSize: this.pageSize,
      auctionId: this.auctionId,
      searchTerm: this.searchTerm
    }
  }

  private getLotResults() {
    this.loader.showLoader(true);
    const pageParams = this.importResult.getLotResults(this.pagingParams()).subscribe((res) => {
      this.loader.showLoader(false);
      this.lotResults = res.data;
      this.totalCount = res.totalCount;
    }, _ => {
      this.loader.showLoader(false);
      this.totalCount = 0;
    })
    this.subscriptions.push(pageParams);
  }

  onPageChange(page: number) {
    this.pageNumber = page
    this.getLotResults();
  }

  goBack() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
  
}

export interface ImportedAuctionUser {
  amount: number;
  auctionId: number;
  auctionUser: {
    contactedOn: string;
    id: number;
    isActive: boolean;
    isAgree: boolean;
    isApproved: boolean;
    isContacted: boolean;
    isNewToPlatform: boolean;
    isReservedBidder: boolean;
    paddleNumber: string;
  }
  auctionUserId: number;
  category: string;
  consignor: string;
  description: string;
  id: number;
  images: [{ id: number; name: string; }];
  location: string;
  lotEndTime: string;
  lotEndTimeUtc: string;
  lotId: number;
  lotNumber: string;
  openingPrice: number;
  quantity: number;
  reservePrice: number;
  thumbnailImages: [{ id: number; name: string; }];
  user: {
    address: { street: string; countryId: number; }
    alternateEmailId: string;
    biography: string;
    companyName: string;
    contactNumber: string;
    createdOn: string;
    email: string;
    fax: string;
    firstName: string;
    id: number;
    isActive: boolean;
    isMfawithEmail: boolean;
    isMfawithSms: boolean;
    lastName: string;
    mfaauthId: number;
    middleName: string;
    mobileNumber: string;
    paddleNumber: string;
    role: number;
  }
}
